import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=3366b85d"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"
import style0 from "./phone.vue?vue&type=style&index=0&id=3366b85d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports